module.exports = __webpack_public_path__ + "static/media/sg7.579db925.png";